// Sample conversion rate
export const czk_eur_rate = 24.64;